import localesManifest from '../locales/locales.json';

const defaultLocale = localesManifest.default;
const supportedLocales = localesManifest.locales;
const canonicalLocaleMap = new Map<string, string>(supportedLocales.map((locale) => [locale.toLowerCase(), locale]));
const legacyOverrides = new Map<string, string>([
    ['bg', 'bg-BG'],
    ['bo', 'bs-BA'],
    ['cs', 'cs-CZ'],
    ['da', 'da-DK'],
    ['de', 'de-DE'],
    ['el', 'el-GR'],
    ['en', 'en-GB'],
    ['en-ie', 'en-GB'],
    ['en-002', 'en-GB'],
    ['en-029', 'en-GB'],
    ['en-145', 'en-GB'],
    ['es', 'es-ES'],
    ['es-419', 'es-ES'],
    ['et', 'et-EE'],
    ['fi', 'fi-FI'],
    ['fr', 'fr-FR'],
    ['fr-002', 'fr-FR'],
    ['hr', 'hr-HR'],
    ['hu', 'hu-HU'],
    ['it', 'it-IT'],
    ['ja', 'ja-JP'],
    ['ko', 'ko-KR'],
    ['lt', 'lt-LT'],
    ['lv', 'lv-LV'],
    ['mk', 'mk-MK'],
    ['nl', 'nl-NL'],
    ['no', 'nb-NO'],
    ['pl', 'pl-PL'],
    ['pt', 'pt-PT'],
    ['ro', 'ro-RO'],
    ['ru', 'ru-RU'],
    ['se', 'sv-SE'],
    ['sl', 'sl-SI'],
    ['sr', 'sr-RS'],
    ['sv', 'sv-SE'],
    ['th', 'th-TH'],
    ['tr', 'tr-TR'],
    ['tw', 'zh-TW'],
    ['uk', 'uk-UA'],
    ['vi', 'vi-VN'],
    ['zh', 'zh-CN']
]);

export type SupportedLocale = (typeof localesManifest.locales)[number];

export function getSupportedLocales(): string[] {
    return [...supportedLocales];
}

export function getDefaultLocale(): string {
    return defaultLocale;
}

export function normalizeLocale(locale?: string | null): string | undefined {
    const trimmed = locale?.trim();

    if (!trimmed) {
        return undefined;
    }

    const normalized = trimmed.toLowerCase();

    const overridden = legacyOverrides.get(normalized);
    if (overridden) {
        return overridden;
    }

    const canonical = canonicalLocaleMap.get(normalized);
    if (canonical) {
        return canonical;
    }

    return trimmed;
}

export function tryResolveSupportedLocale(locale?: string | null): string | undefined {
    const normalized = normalizeLocale(locale);
    if (!normalized) {
        return undefined;
    }

    return canonicalLocaleMap.get(normalized.toLowerCase());
}

export function resolveLocale(locale?: string | null): string {
    return tryResolveSupportedLocale(locale) ?? defaultLocale;
}
